import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
    tmpBuffer: undefined,
    list: {
        filterValues: {
            sender: null,
        },
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
